import { createTheme } from '@material-ui/core/styles';

const qdashTheme = createTheme({
	palette: {
		primary: {
			main: '#0c69b0', // Primary blue from unity
		},
		secondary: {
			main: '#dd3333', // Delete button from unity
		},
		error: {
			main: '#B00020',
		},
	},
	zIndex: {
		appBar: 1000,
	},
});

export { qdashTheme };
